import { Trash2 } from 'lucide-react';

interface DeletePatientButtonContentProps {
  children: React.ReactNode;
}

function DeletePatientButtonContent({ children }: DeletePatientButtonContentProps) {
  return (
    <div className="flex w-full items-center justify-center gap-2">
      <Trash2 size="12" />
      {children}
    </div>
  );
}

export default DeletePatientButtonContent;
